// extracted by mini-css-extract-plugin
export default {"loadingSpinner":"Loading_loadingSpinner__SgPVW","spin":"Loading_spin__iZWN+"};